// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMeta from 'vue-meta'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import showData from './router/sdata'
import ppp from './router/ppp'
import './assets/font/fonts.css'


Vue.use(ElementUI)
Vue.use(VueMeta)

//禁用生产模式下的提示
Vue.config.productionTip = false

const token = ''

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  data: {
    showData,
    token,
    ppp
  }
})


// WEBPACK FOOTER //
// ./src/main.js